import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const NewWindow = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 28H9C6.237 28 4 25.762 4 23V9C4 6.237 6.237 4 9 4H13C13.55 4 14 4.45 14 5C14 5.55 13.55 6 13 6H9C7.35 6 6 7.35 6 9V23C6 24.65 7.35 26 9 26H23C24.65 26 26 24.65 26 23V19C26 18.45 26.45 18 27 18C27.55 18 28 18.45 28 19V23C28 25.762 25.762 28 23 28Z" />
		<path d="M27 4H19C18.45 4 18 4.45 18 5C18 5.55 18.45 6 19 6H24.587C20.849 9.738 12.3 18.288 12.3 18.288C12.125 18.463 12.013 18.713 12.013 19C12.013 19.55 12.463 20 13.013 20C13.288 20 13.538 19.887 13.726 19.712C13.726 19.712 22.289 11.149 26.013 7.425V13C26.013 13.55 26.463 14 27.013 14C27.563 14 28.013 13.55 28.013 13V5C28.001 4.45 27.551 4 27.001 4H27Z" />
	</svg>
);

export default NewWindow;
